import React from "react";
import { Link } from "react-router-dom";
import Btn from "../../Components/Btn";
import { PasswordCheck } from "../../Utils/icons";
import { usePassword } from "./Hook";
import "./style.scss";
import { p2e } from "../../Utils/functions";

const Password = () => {
  const { form, setForm, loading, send , state } = usePassword();
  return (
    <div>
      <div className="input-mobile">
        <div className="icon-wrapper">
          <PasswordCheck />
        </div>
        <input
          autoFocus={true}
          type="password"
          value={form.password}
          onChange={({ target: { value } }) => {
            setForm({ ...form, password: p2e(value) });
          }}
          onKeyDown={({ key }) => {
            if (key === "Enter") {
              send();
            }
          }}
        />
      </div>
      <Btn
        onClick={send}
        text={"تایید گذرواژه"}
        className="mb-10"
        loading={loading}
      />
      <div className="link-auth-wrapper">
        <Link
          className="link-auth  fs-10 fw-600 lh-17 text-main"
          to={`/otp?resend=${state}`}
        >
          ورود با کد یکبار مصرف پیامکی (OTP)
        </Link>
      </div>
    </div>
  );
};

export default Password;
